import { TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import type { BillingPlanTier } from '@core/products-types';
import { RtTooltip, BadgeComponent, HeadingComponent } from '@core/user-interface-legacy';

import { ProductNamePipe } from '../../product-name/product-name.pipe';
import { PlanPickerProductDescriptionPipe } from '../plan-picker-product-description.pipe';

@Component({
  selector: 'rt-plan-picker-product-header',
  templateUrl: './plan-picker-product-header.component.html',
  styleUrls: ['./plan-picker-product-header.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    HeadingComponent,
    BadgeComponent,
    RtTooltip,
    ProductNamePipe,
    TranslatePipe,
    TitleCasePipe,
    PlanPickerProductDescriptionPipe,
  ],
})
export class PlanPickerProductHeaderComponent {
  @Input() public codename: BillingPlanTier;
  @Input() public showCustomBadge: boolean;
  @Input() public showTrialPlanBadge: boolean;
}
